import { useState } from 'react'
import { Head } from '@inertiajs/react'
import { Boxes, CalendarDays, Files, GitBranch, Network } from 'lucide-react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import FdeShell from '@/frontend/features/Fde/FdeShell'
import ForgePane from '@/frontend/features/Fde/ForgePane'
import ForgeStage from '@/frontend/features/Fde/ForgeStage'
import ProjectControls from '@/frontend/features/Fde/ProjectControls'
import ProjectDialog from '@/frontend/features/Fde/ProjectDialog'
import type { Project, SectionProps } from '@/frontend/features/Fde/types'
import { fdeRoutes } from '@/frontend/features/Fde/routes'

const routeBySection = { overview: fdeRoutes.overview, data: fdeRoutes.data, workflows: fdeRoutes.workflows }

function SectionPage(props: SectionProps) {
  const [projectDialog, setProjectDialog] = useState<{ open: boolean; project: Project | null }>({ open: false, project: null })
  const sectionCopy = props.copy.sections[props.section]
  const actions = <ProjectControls path={routeBySection[props.section]} project={props.project} projects={props.project_history} copy={props.copy} canManage={props.can_manage} onEdit={() => setProjectDialog({ open: true, project: props.project })} onNew={() => setProjectDialog({ open: true, project: null })} />
  const metrics = [
    { key: 'events', label: props.copy.navigation.timeline, icon: CalendarDays },
    { key: 'files', label: props.copy.navigation.workspace, icon: Files },
    { key: 'elements', label: props.copy.workspace.elements, icon: Boxes },
    { key: 'relationships', label: props.copy.workspace.relationships, icon: GitBranch },
    { key: 'decisions', label: props.copy.navigation.outcomes, icon: Network },
  ]

  return (
    <>
      <Head title={props.page_title} />
      <FdeShell copy={props.copy} eyebrow="" title={props.project?.name ?? sectionCopy.title} description={sectionCopy.description} actions={actions} projectId={props.project?.id}>
        <ForgeStage props={props} primaryLabel={sectionCopy.title} refreshProps={['metrics']} renderPrimary={(headerActions) => (
          <ForgePane title={sectionCopy.title} description={sectionCopy.description} headerActions={headerActions}>
            {props.section === 'overview' ? (
              <div className="grid gap-px bg-border p-px sm:grid-cols-2 xl:grid-cols-5">
                {metrics.map(({ key, label, icon: Icon }) => <div key={key} className="bg-background p-5"><Icon className="size-4 text-muted-foreground" /><p className="mt-4 text-2xl font-semibold tabular-nums">{props.metrics[key] ?? 0}</p><p className="mt-1 text-xs text-muted-foreground">{label}</p></div>)}
              </div>
            ) : (
              <div className="flex h-full items-center justify-center p-8 text-center"><div className="max-w-md"><Network className="mx-auto size-8 text-muted-foreground" /><p className="mt-3 text-sm text-muted-foreground">{sectionCopy.empty}</p></div></div>
            )}
          </ForgePane>
        )} />
      </FdeShell>
      <ProjectDialog open={projectDialog.open} onOpenChange={(open) => setProjectDialog((current) => ({ ...current, open }))} project={projectDialog.project} agents={props.agents} copy={props.copy} activeProjectId={props.project?.id} />
    </>
  )
}

SectionPage.layout = (page: React.ReactElement) => <DashboardLayout variant="fullscreen">{page}</DashboardLayout>
export default SectionPage
